<template>
    <div>
        <div class="mt-4 md:mt-7 pb-5 md:flex md:items-center md:justify-between">
            <h3 class="text-center md:text-left m-0">
                請選擇欲約定帳號之保單
            </h3>
            <div
                v-if="dataNormal.length + dataWithMemo.length > 0"
                class="hidden md:block toggle-box"
            >
                <SwitchPolicyForm
                    :is-toggle-on="isCardLayout"
                    @click="isCardLayout = !isCardLayout"
                />
            </div>
        </div>
        <div>
            <transition
                name="opacity"
                mode="out-in"
            >
                <div
                    v-if="isCardLayout || isWidthLess780"
                    class="mx-auto max-w-[24.375rem] pad:max-w-full "
                >
                    <transition
                        name="opacity"
                        mode="out-in"
                    >
                        <div
                            v-if="isSkeletonShow"
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-x-[1.875rem] pad:mt-3.5"
                        >
                            <SkeletonCardPolicy
                                v-for="i in 3"
                                :key="i"
                            />
                        </div>

                        <div
                            v-else
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-[1.875rem]"
                        >
                            <div v-if="aplCatl === 'A6'">
                                <A6CardPolicy
                                    v-for="item in dataNormal"
                                    :key="item.id"
                                    :data="item"
                                    class="mb-4 last:mb-0 md:mb-0"
                                    :columns="Columns"
                                    @click="toServicePage(item)"
                                >
                                    <button
                                        class="btn-text border-b-2 border-gray-400 leading-none"
                                        @click.stop="getDetail(item)"
                                    >
                                        {{ item.bnkAcct ? '原約定帳號' : '未指定' }}
                                    </button>
                                </A6CardPolicy>
                            </div>
                            <div v-else-if="aplCatl === 'A3' || aplCatl === 'A4' || aplCatl === 'A5'">
                                <CardPolicy
                                    v-for="item in dataNormal"
                                    :key="item.id"
                                    :data="item"
                                    class="mb-4 last:mb-0 md:mb-0"
                                    :columns="Columns"
                                    @click="toServicePage(item)"
                                >
                                    <button
                                        class="btn-text border-b-2 border-gray-400 leading-none"
                                        @click.stop="getDetail(item)"
                                    >
                                        {{ item.bnkAcct ? '原約定帳號' : '未指定' }}
                                    </button>
                                </CardPolicy>
                            </div>
                            <div v-else>
                                <CardPolicy
                                    v-for="item in dataNormal"
                                    :key="item.id"
                                    :data="item"
                                    class="mb-4 last:mb-0 md:mb-0"
                                    :columns="Columns"
                                    @click="toServicePage(item)"
                                >
                                    <button
                                        class="btn-text border-b-2 border-gray-400 leading-none"
                                        @click.stop="getDetail(item)"
                                    >
                                        {{ item.bnkAcct ? '約定明細' : '未指定' }}
                                    </button>
                                </CardPolicy>
                            </div>
                        </div>
                    </transition>
                </div>
                <TablePolicy
                    v-else
                    :data="dataNormal"
                    :columns="Columns"
                    @toServicePage="toServicePage"
                    @getDetail="getDetail"
                />
            </transition>
            <noData
                v-show="data!==null && dataNormal.length === 0"
                class="max-w-[24.375rem] pad:max-w-full mx-auto mt-2"
            >
                您目前沒有任何有效的保單
            </noData>
        </div>
        <div>
            <h4 class="mx-auto max-w-[24.375rem] pad:max-w-full py-[0.9375rem] mt-5 pad:py-5">
                因相關申請中暫時無法辦理之保單
            </h4>
            <transition
                name="opacity"
                mode="out-in"
            >
                <div
                    v-if="isCardLayout || isWidthLess780"
                    class="mx-auto max-w-[24.375rem] pad:max-w-full"
                >
                    <transition
                        name="opacity"
                        mode="out-in"
                    >
                        <div
                            v-if="isSkeletonShow"
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-x-[1.875rem]"
                        >
                            <SkeletonCardPolicy
                                v-for="i in 3"
                                :key="i"
                            />
                        </div>
                        <div
                            v-else
                            class="pad:grid pad:grid-cols-2 lg:grid-cols-3 pad:gap-[1.875rem]"
                        >
                            <CardPolicy
                                v-for="item in dataWithMemo"
                                :key="item.id"
                                :data="item"
                                class="mb-4 last:mb-0 md:mb-0"
                                disabled
                                :columns="Columns"
                            />
                        </div>
                    </transition>
                </div>

                <TablePolicy
                    v-else
                    :data="dataWithMemo"
                    :columns="Columns"
                    disabled
                />
            </transition>
            <noData
                v-if="data!==null && dataWithMemo.length === 0"
                class="max-w-[24.375rem] pad:max-w-full mx-auto mt-2"
            >
                您目前沒有申請中的保單
            </noData>
        </div>

        <Loading :is-loading="isLoading" />
        <PopupDetail
            v-model:isPopup="isPopup"
            :data="popupData"
        />
    </div>
</template>
<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
import { useEventListener } from '@vueuse/core';
import noData from '@/components/text/EmptyData.vue';
import CardPolicy from './CardPolicy.vue';
import A6CardPolicy from './A6CardPolicy.vue';
import SkeletonCardPolicy from '@/components/skeletons/SkeletonCardPolicy.vue';
import TablePolicy from './TablePolicy.vue';
import SwitchPolicyForm from './SwitchPolicyForm.vue';
import Loading from '@/components/Loading.vue';
import PopupDetail from './PopupDetail.vue';
import { policyOverview, selectChangedPolicy, startTransaction } from '@/apis/system.js';

export default {
    name: 'Policy',
    components: {
        noData,
        CardPolicy,
        A6CardPolicy,
        TablePolicy,
        SwitchPolicyForm,
        SkeletonCardPolicy,
        Loading,
        PopupDetail,
    },
    setup() {
        const router = useRouter();
        // const route = useRoute();
        const store = useStore();
        const aplCatl = computed(() => store.state.permissions.aplCatl);
        const isLoading = ref(false);
        const isSkeletonShow = ref(true);
        const text = ref(null);
        const isCardLayout = ref(true);
        const isWidthLess780 = ref(window.innerWidth < 780);
        const data = ref(null);
        const isPopup = ref(false);
        const popupData = ref({

        });
        const dataNormal = ref([]);
        const dataWithMemo = ref([]);
        let Columns = ref([]);
        switch (aplCatl.value) {
            case 'A6':
                Columns = ['保單號碼', '幣別', '被保險人', '給付日期', '給付項目', '給付帳號'];
                break;
            case 'A3':
                Columns = ['保單號碼', '幣別', '被保險人', '預計給付日', '給付項目', '給付帳號'];
                break;
        }
        // const isInvenstment = ref(route.name === routeName.POLICY_INVESTMENT);
        const getData = () => {
            policyOverview(aplCatl.value).then(res => {
                data.value = res.data?.policyList || [];
                dataNormal.value = data.value.filter(i => i.memo.length === 0);
                dataWithMemo.value = data.value.filter(i => i.memo.length !== 0);
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                isSkeletonShow.value = false;
            });
        };

        getData();

        const changeLayout = () => {
            isCardLayout.value = !isCardLayout.value;
        };

        const toServicePage = (item) => {
            isLoading.value = true;
            const requestBody = {
                policyNo: item.policyNo,
                policySeq: item.policySeq,
                idDup: item.idDup,
                srceFrom: item.srceFrom
            };
            selectChangedPolicy(requestBody).then(() => {
                store.dispatch('policy/setPolicy', item);
                startTransaction().then(() => {
                    let page = '';
                    switch (aplCatl.value) {
                        case 'A3':
                            page = routeName.A3_SELECT_POLICY;
                            router.push({ name: page });
                            router.push({ name: routeName.A3_SET_ACCONT });
                            break;
                        case 'A6':
                            page = routeName.A6_SELECT_POLICY;
                            router.push({ name: page });
                            router.push({ name: routeName.A6_SET_ACCONT });
                            break;
                    }
                }).finally(() => {
                    isLoading.value = false;
                });
            }).catch(err => {
                isLoading.value = false;
                console.log(err);
            }).finally(() => {
                // isLoading.value = false;
            });
        };

        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                isWidthLess780.value = window.innerWidth < 780;
            });
        });

        const getDetail = (item) => {
            popupData.value = item;
            isPopup.value = true;
        };
        return {
            isCardLayout,
            isWidthLess780,
            changeLayout,
            toServicePage,
            text,
            dataWithMemo,
            isLoading,
            isSkeletonShow,
            dataNormal,
            data,
            getDetail,
            isPopup,
            Columns,
            popupData,
            aplCatl,
        };
    },

};
</script>
